<template>
  <view-container>
    <v-form v-model="isValid">
      <v-card>
        <v-card-text>
          <reference-field
            v-if="showClientFilter"
            label="Клиент"
            reference="client"
            v-model="cashier.clientId"
            :readonly="!!this.id"
            :rules="rules.clientId"
          />
          <reference-field
            label="Группа касс"
            reference="group"
            :disabled="!cashier.clientId && !user.clientId"
            :readonly="user.isPartner"
            item-text="nameWithCompany"
            :rels="['company']"
            v-model="cashier.groupId"
            :filter="groupFilter"
            :rules="rules.groupId"
            default-one
          />
          <v-text-field
            label="Имя кассира"
            v-model="cashier.name"
            :rules="rules.name"
            hint="можно перечислить несколько через запятую, по-умолчанию используется первое"
            :readonly="user.isPartner"
          />
          <phone-number-field
            label="Номер телефона"
            v-model="cashier.phoneNumber"
            :rules="rules.phoneNumber"
            prefix="7"
            hint="используется в качестве логина для мобильного приложения"
            :readonly="user.isPartner"
          />
          <v-text-field
            label="Должность (опционально)"
            v-model="cashier.title"
            placeholder="кассир"
            :rules="rules.title"
            hint="должность кассира (курьер, водитель итп)"
            :readonly="user.isPartner"
          />
          <v-text-field
            label="ИНН (опционально)"
            hint="при наличии, обязательно укажите для кассира, ответственного за закрытие и открытие смен"
            v-model="cashier.inn"
            :readonly="user.isPartner"
            :rules="rules.inn"
          />
          <v-text-field
            label="Место расчёта по-умолчанию (опционально)"
            hint="например, номер автомобиля"
            v-model="cashier.place"
            :readonly="user.isPartner"
            :rules="rules.place"
          />
          <reference-field
            label="Номенклатурная группа (опционально)"
            reference="itemGroup"
            hint="выберите группу номенклатурных позиций для отображения в приложении"
            v-model="cashier.itemGroupId"
            :rules="rules.itemGroupId"
            :disabled="!cashier.clientId && !user.clientId"
            :readonly="user.isPartner"
            :filter="groupFilter"
          />
          <v-switch
            v-model="cashier.active"
            label="активен"
            :disabled="isActivationDisabled"
            :readonly="user.isPartner"
            :messages="overdraftMessage"
          >
          </v-switch>
        </v-card-text>
        <v-card-actions v-if="!user.isPartner">
          <v-btn @click="save" :disabled="!isValid">Сохранить</v-btn>
          <v-btn text @click="cancel">Отмена</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </view-container>
</template>
<script>
import ds from "@/datastore";
export default {
  name: "CashierDetails",
  props: {
    id: String,
    clientId: String
  },
  data() {
    return {
      cashier: {
        clientId: this.clientId
      },
      isValid: false,
      maxCashiers: 0,
      activeCashiers: 0,
      isActivationDisabled: false
    };
  },
  async activated() {
    await this.loadClientInfo();
    if (this.id) {
      let item = await ds.find("cashier", this.id);
      this.cashier = ds.createRecord("cashier", item.toJSON(), {
        noValidate: true
      });
    } else {
      this.cashier = ds.createRecord(
        "cashier",
        {
          clientId: this.user.clientId || this.clientId,
          active: this.canActivate()
        },
        { noValidate: true }
      );
    }
    if (this.user.isAdmin) {
      this.isActivationDisabled = false;
    } else {
      this.isActivationDisabled = this.cashier.active
        ? false
        : !this.canActivate();
    }
  },
  watch: {
    "cashier.clientId": function(newVal, oldVal) {
      if (oldVal) {
        this.cashier.groupId = null;
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    },
    showClientFilter() {
      return !this.user.clientId;
    },
    groupFilter() {
      return { clientId: this.cashier.clientId };
    },
    rules() {
      return this.cashier.$rules || {};
    },
    overdraftMessage() {
      return this.isActivationDisabled
        ? "Достигнут лимит активных кассиров (" +
            this.maxCashiers +
            "). Добавление новых активных кассиров невозможно."
        : "";
    }
  },
  methods: {
    async save() {
      let item = await this.cashier.save();
      this.$store.commit("notifications/success", "Кассир сохранен");
      if (!this.id) {
        this.$router.replace({
          name: "cashier-access",
          params: { id: item.id, isNew: true }
        });
        return;
      }
      this.cancel();
    },
    cancel() {
      this.$destroy();
      this.$router.go(-1);
    },
    canActivate() {
      return this.maxCashiers > this.activeCashiers;
    },
    async loadClientInfo() {
      let id = this.user.clientId || this.clientId;
      if (id) {
        let client = await ds.find("client", id);
        this.maxCashiers = client.maxCashiers || 0;
        this.activeCashiers = (await client.countActiveCashiers()) || 0;
        return;
      }
    }
  }
};
</script>
